export const dictionary = {
  TITLE: {
    ES: "Tus pedidos",
    EN: "Your orders",
  },
  ORDER_NUMBER: {
    ES: "Pedido número ",
    EN: "Order number ",
  },
  CANCEL_ORDER: {
    ES: "Cancelar pedido",
    EN: "Cancel order",
  },
  PROCESSED_ORDER: {
    ES: "Procesar pedido",
    EN: "Processed order",
  },
  SET_ORDER: {
    ES: "Marcar como ",
    EN: "Set order as ",
  },
  CALL: {
    ES: "Llamar",
    EN: "Call",
  },
  ALL: {
    ES: "todos",
    EN: "all",
  },
  RECEIVED: {
    ES: "pedido recibido",
    EN: "order received",
  },
  PAYMENT_RECEIVED: {
    ES: "pago recibido",
    EN: "payment received",
  },
  DELIVERED: {
    ES: "pedido entregado",
    EN: "delivered",
  },
  DELIVERED_MENU: {
    ES: "pedido procesado",
    EN: "processed",
  },
  ORDER_CANCELLED: {
    ES: "pedido cancelado",
    EN: "cancelled",
  },
  FILTER: {
    ES: "Filtrar por",
    EN: "Filter by",
  },
  CANCELLED: {
    ES: "Cancelado",
    EN: "Cancelled",
  },
  WHATSAPP_MESSAGE: {
    ES: "Hola, hemos recibido tu pedido. \n Pedido:  \n",
    EN: "Hi, we have received your order.",
  },
  INFO: {
    ES: "Información adicional",
    EN: "Additional information",
  },
  VIEW_ORDER: {
    ES: "Ver pedido",
    EN: "View order",
  },
  EMPTY_LIST: {
    ES: "Aún no tienes pedidos",
    EN : "No orders yet"
  }
} as const;
